import { useTranslation } from "react-i18next";

import type { ClientNotice } from "./store.js";

interface CommandNoticeProps {
  notice: ClientNotice;
  onDismiss: () => void;
}

export function CommandNotice({ notice, onDismiss }: CommandNoticeProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`notification-item is-${notice.kind} is-command`}
      role={notice.kind === "error" ? "alert" : "status"}
      aria-live="polite"
      data-testid="command-toast"
    >
      <span className="notification-symbol" aria-hidden="true">
        {notice.kind === "success" ? "✓" : "!"}
      </span>
      <span>{t(notice.messageKey, notice.params ?? {})}</span>
      {notice.kind === "error" ? (
        <button type="button" aria-label={t("common.dismiss")} onClick={onDismiss}>
          ×
        </button>
      ) : null}
    </div>
  );
}
